module.exports = __webpack_public_path__ + "static/img/swiperadmin3.4cbab21.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imges/scheme/swiperadmin3.png
// module id = /Ba9
// module chunks = 1